const data = {
    title: "Oops!",
    text: "404 - Something went wrong!",
    button: {
        text: "Back to Home",
    }
}

export default data;